import { useLocation } from 'react-router-dom';

const BASE_URL = 'https://findyourdunsnumber.com';

const useCurrentURL = () => {
  const location = useLocation();

  // Build canonical URL from pathname (excludes query params and hash for clean canonicals)
  const canonicalURL = `${BASE_URL}${location.pathname}`;

  return canonicalURL;
};

export default useCurrentURL;
